import React, { PureComponent } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, mFormatter, kmFormatter, intToRGB, hashCode } from "../utils";
import HighchartsCustomEvents from "highcharts-custom-events";
import moment from "moment-timezone";
import UpIcon from "../../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../../assets/svg/arrow-down.svg";

HighchartsCustomEvents(Highcharts);

class ShareOfVoiceWithSubtopicsChart extends PureComponent {
    constructor(props) {
        super(props);
        this.chartComponent = React.createRef();
    }
    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }
    getBarOptions = () => {
        let chartConfig = {};
        let chartData = this.props.data.chartDataBar;
        let total = this.props.data.total;
        let self = this;

        chartConfig = {
            chart: {
                type: "bar",
                className: "skiptranslate",
                backgroundColor: "transparent",
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },
            xAxis: {
                type: "category",
                lineWidth: 1,
                labels: {
                    formatter: function () {
                        let value = this.value.length > 20 ? this.value.substring(0, 20) + "..." : this.value;
                        return value;
                    },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: {
                    text: ``,
                },
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    stacking: "normal",
                    dataLabels: {
                        enabled: this.props.showLabel,
                        inside: false,
                        formatter: function () {
                            return kmFormatter(this.y);
                        },
                        style: {
                            color: "#333333",
                            textOutline: "none",
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                    events: {
                        legendItemClick: function () {
                            if (this.visible) {
                                this.setData([], false);
                            } else {
                                this.setData(chartData[this.index].data, false);
                            }
                        },
                    },
                },
            },
            legend: {
                enabled: this.props.showLegend,
                width: "20%",
                layout: "vertical",
                align: "right",
                padding: 3,
                itemMarginTop: 3,
                itemMarginBottom: 3,
                verticalAlign: "middle",
                alignColumns: true,
                itemStyle: {
                    fontWeight: 500,
                    textTransform: "normal",
                    fontFamily: "'Roboto', sans-serif",
                },
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series: chartData,
            tooltip: {
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `${this.key} | ${this.series.userOptions.topic_name} |<b>${((this.y * 100) / total).toFixed(1) + "%"}</b> | <b>${numberWithCommas(
                        this.y,
                    )}/${numberWithCommas(total)}</b>`;
                },
            },
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 500,
                        },
                        chartOptions: {
                            legend: {
                                labelFormatter: function () {
                                    let name = this.name.length > 12 ? this.name.substring(0, 12) + "..." : this.name;
                                    return name;
                                },
                            },
                            xAxis: {
                                labels: {
                                    formatter: function () {
                                        let value = this.value.length > 12 ? this.value.substring(0, 12) + "..." : this.value;
                                        return value;
                                    },
                                },
                            },
                        },
                    },
                ],
            },
        };
        return chartConfig;
    };
    getPieOptions = () => {
        let chartConfig = {};
        let self = this;
        let chartData = this.props.data.chartDataPie;
        let total = this.props.data?.total || 0;

        chartConfig = {
            chart: {
                type: "pie",
                className: "skiptranslate",
                backgroundColor: "transparent",
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                verticalAlign: "middle",
                text: "",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                y: 2,
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    shadow: false,
                    borderWidth: 0,
                    showInLegend: true,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        distance: "10%",
                        formatter: function () {
                            let key = this.key;
                            return key + " : " + this.percentage.toFixed(1) + "%";
                        },
                        style: {
                            fontWeight: 400,
                            textOutline: "none",
                        },
                        padding: 0,
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    textTransform: "normal",
                },
                alignColumns: false,
                maxHeight: 55,
                navigation: {
                    enabled: false,
                },
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series: [
                {
                    data: chartData,
                },
            ],
            tooltip: {
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `${this.point.name}  | ${this.point.options.topic_name} | <b>${this.point.percentage.toFixed(1) + "%"}</b> | <b>${numberWithCommas(
                        this.point.y,
                    )}/${numberWithCommas(total)} </b>`;
                },
            },
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 500,
                        },
                        chartOptions: {
                            legend: {
                                labelFormatter: function () {
                                    let name = this.name.length > 12 ? this.name.substring(0, 12) + "..." : this.name;
                                    return name;
                                },
                            },
                            plotOptions: {
                                pie: {
                                    dataLabels: {
                                        formatter: function () {
                                            let key = this.key.length > 12 ? this.key.substring(0, 12) + "..." : this.key;
                                            return key + " : " + this.percentage.toFixed(1) + "%";
                                        },
                                    },
                                },
                            },
                        },
                    },
                ],
            },
        };
        return chartConfig;
    };
    getLineOptions = () => {
        let data = this.props.data.chartDataLine;
        let self = this;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;
        let comparisionData = this.props.comparisionData && this.props.comparisionData.chartDataLine;
        let newComparisionData = [];
        if (comparisionData?.length > 0) {
            data.forEach((ele) => {
                let subId = ele.subtopicId;
                let data_index = comparisionData.filter((ele) => ele.subtopicId === subId);
                newComparisionData.push(data_index[0]);
            });
            comparisionData = newComparisionData;
        }
        if (data.length > 9) {
            let subtopics = [];
            let items = [];
            let total = 0;
            let slicedData = data.slice(0, 9);
            let othersLineData = {};
            for (let i = 9; i < data.length; i++) {
                total += data[i].y;
                subtopics.push(data[i].subtopicId);
                items.push({ name: data[i].name, value: data[i].y });
                data[i].data.map((d) => {
                    if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                    else othersLineData[d.x] = d.y;
                });
            }
            let x = [];
            Object.keys(othersLineData).map((k) => x.push({ x: +k, y: othersLineData[k] }));
            slicedData.push({
                data: x,
                name: "Others",
                topic_name: "Others",
                value: total,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
                items,
            });
            data = slicedData;
        }
        if (comparisionData?.length > 9) {
            let subtopics = [];
            let items = [];
            let total = 0;
            let slicedData = comparisionData.slice(0, 9);
            let othersLineData = {};
            for (let i = 9; i < comparisionData.length; i++) {
                total += comparisionData[i].y;
                subtopics.push(comparisionData[i].subtopicId);
                items.push({ name: comparisionData[i].name, value: comparisionData[i].y });
                comparisionData[i].data.map((d) => {
                    if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                    else othersLineData[d.x] = d.y;
                });
            }
            let x = [];
            Object.keys(othersLineData).map((k) => x.push({ x: +k, y: othersLineData[k] }));
            slicedData.push({
                data: x,
                name: "Others",
                topic_name: "Others",
                value: total,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
                items,
            });
            comparisionData = slicedData;
        }
        data &&
            data.map((d, i) => {
                if (d.color?.length == 0) d.color = "#000000";
            });
        if (comparisionData) {
            comparisionData.forEach((d, i) => {
                d.linkedTo = ":previous";

                if (d.color?.length == 0) d.color = "#00000055";
                else if (d.color?.length <= 7) d.color = d.color + "55";
            });
        }

        let plotComaprisiondata;
        let arrayCombined = [];

        let plotComaprisiondataCondition = comparisionData && comparisionData[0]?.data.length >= data[0]?.data.length;

        if (plotComaprisiondataCondition && data) {
            plotComaprisiondata = JSON.parse(JSON.stringify(data));

            comparisionData.forEach((ele, index) => {
                ele.data.forEach((element, ind) => {
                    if (plotComaprisiondata[index].data[ind]) {
                        plotComaprisiondata[index].data[ind].originalX = plotComaprisiondata[index].data[ind].x;
                        plotComaprisiondata[index].data[ind].x = element.x;
                    }
                });
            });
        } else {
            if (comparisionData) {
                plotComaprisiondata = JSON.parse(JSON.stringify(comparisionData));

                this.props.data &&
                    data.forEach((ele, index) => {
                        ele.data.forEach((element, ind) => {
                            if (plotComaprisiondata[index].data[ind]) {
                                plotComaprisiondata[index].data[ind].originalX = plotComaprisiondata[index].data[ind].x;
                                plotComaprisiondata[index].data[ind].x = element.x;
                            }
                        });
                    });
            }
        }

        if (comparisionData) {
            plotComaprisiondataCondition
                ? data.forEach((element, ind) => {
                      let comparisionIndex = comparisionData.find((ele) => ele.subtopicId == element.subtopicId);

                      arrayCombined.push(plotComaprisiondata[ind]);
                      if (comparisionIndex) arrayCombined.push(comparisionIndex);
                  })
                : comparisionData.forEach((element, ind) => {
                      let plotComparisionIndex = plotComaprisiondata.find((ele) => ele.subtopicId == element.subtopicId);

                      arrayCombined.push(data[ind]);
                      if (plotComparisionIndex) arrayCombined.push(plotComparisionIndex);
                  });
        }
        arrayCombined.map((d, i) => {
            if (i > 3) {
                d.visible = false;
            }
        });

        let serObj = this.props.comparisionData ? arrayCombined : data;
        const chartOptions = {
            chart: {
                type: "spline",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },

            xAxis: {
                lineColor: "#ccd6eb",
                lineWidth: 1,
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    labels: {
                        format: "{value:%b %e}",
                    },
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            tooltip: {
                shared: plotComaprisiondata ? true : false,
                outside: true,
                crosshairs: true,
                useHTML: true,
                className: "skiptranslate",
                formatter: function () {
                    if (plotComaprisiondata) {
                        let str = "";
                        let ComapareVal1;
                        let ComapareVal2;
                        let dateCompare;
                        let showPercent = true;
                        for (let i = 0; i < this.points.length; i++) {
                            let temp = "";
                            ComapareVal1 = this.points[0].y;
                            ComapareVal2 = this.points[1]?.y;
                            dateCompare = this.points[1]?.point.options.originalX > this.points[1]?.point.options.x;
                            let firstColorPoint = this.points[1]?.color.endsWith("55");
                            let secondColorPoint = this.points[0]?.color.endsWith("55");

                            if ((firstColorPoint && secondColorPoint) || (!secondColorPoint && !firstColorPoint)) {
                                showPercent = false;
                            }

                            temp = `<b>${moment(this.points[i].point.originalX ? this.points[i].point.originalX : this.points[i].x)
                                .tz(tz)
                                .format(
                                    "LLLL",
                                )}</b><br/><div  style="margin-bottom:10px;"><span style="margin-right:10px;display:inline-block;width:8px;height:8px;background-color:${
                                this.points[i].color
                            };border-radius:10px" ></span>
                          
                            <b >${numberWithCommas(this.points[i].y)}</b> </div>`;

                            str += temp;
                        }
                        if (this.points.length == 2 && showPercent) {
                            str += `${
                                ComapareVal1 < ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal1 !== 0 ? (((ComapareVal2 / ComapareVal1).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                <img src=${dateCompare ? UpIcon : DownIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          dateCompare && "rotate(180deg)"
                                      }" />
                                </div>
                             
                            
                            
                                
                                </div>`
                                    : ComapareVal1 > ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal2 !== 0 ? (((ComapareVal1 / ComapareVal2).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                    <img src=${dateCompare ? DownIcon : UpIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          !dateCompare && "rotate(180deg)"
                                      }" />
                                    </div>
                                 
                                
                                
                                    
                                    </div>`
                                    : ""
                            }`;
                        }

                        return str;
                    } else {
                        return `${moment(this.x).tz(tz).format("LLLL")}<br/>${this.point.series.name} | ${
                            this.point.series.userOptions.topic_name
                        }: <b>${numberWithCommas(this.y)}</b>`;
                    }
                },

                backgroundColor: "#fff",
                borderRadius: 6,
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: " ",
            },
            series: serObj,
            plotOptions: {
                spline: {
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },

            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
            },
            time: {
                timezoneOffset: tzo,
            },
        };

        return chartOptions;
    };

    render() {
        return (
            <>
                {this.props.currentChartType === "bar" && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getBarOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                    />
                )}
                {this.props.currentChartType === "pie" && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getPieOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                    />
                )}
                {this.props.currentChartType === "line" && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getLineOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                    />
                )}
            </>
        );
    }
}
export default ShareOfVoiceWithSubtopicsChart;
